import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = [ "loading", "active" ]

  connect() {
    this.element.addEventListener("click", this.handleClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick)
  }

  handleClick = () => {
    this.element.classList.add(this.loadingClass)
  }

  complete = () => {
    this.element.classList.remove(this.loadingClass)
    this.element.classList.toggle(this.activeClass)
  }
}
